import { eachDayOfInterval, endOfWeek, format, startOfWeek } from 'date-fns';

export const formatDateTime = (date: Date): string => format(date, 'yyyy-LL-dd HH:mm:ss');

export const formatDate = (date: Date): string => format(date, 'yyyy-LL-dd');

export const getWeekDays = (dayFormat: string = 'EEEE'): string[] =>
{
    const weekDays: string[] = [];
    const now = new Date();
    const start = startOfWeek(now, { weekStartsOn: 1, });
    const end = endOfWeek(now, { weekStartsOn: 1, });

    eachDayOfInterval({ start, end }).forEach((day) =>
    {
        weekDays.push(format(day, dayFormat));
    });

    return weekDays;
};

export const getWeekDay = (index: number): string =>
{
    return getWeekDays()[index];
}

export const getTodayWeekDay = (): string =>
{
    const todayIndex = new Date().getDay(); // Returns 0 (Sunday) to 6 (Saturday)
    const weekDays = getWeekDays(); // Get the array of weekdays using your existing function

    // Adjust the index if your week starts on Monday
    return weekDays[todayIndex === 0 ? 6 : todayIndex - 1]; // Make Sunday the last day
};

